import instance from './http.service';

const AuthServices = {
  updateProfile: (body) => {
    return instance.put(`/update-profile`, body);
  },
  setUsername: (body) => {
    return instance.put(`/set-username`, body);
  },
  checkUsername: (username) => {
    return instance.get(`/check-username`, { params: { username } });
  },
  getWalletChallenge: (body) => {
    return instance.post(`/wallet-challenge`, body);
  },
  connectToWallet: (body) => {
    return instance.post(`/wallet-signin`, body);
  },
  verify: (body) => {
    return instance.post(`/verify`, body);
  },
  logout: () => {
    return instance.delete(`/signout`);
  },
};

export default AuthServices;
